import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { GeneralCard } from '../../../../components/Cards/GeneralCard';
import GeneralSectionForm from './GeneralSectionForm';
import './PartConfigurationGrid.css';
import { getPartInfo } from '../../services/PartsConfigurationService';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { PartConfigurationContext, usePartValue } from '../../contexts/PartConfigurationContext';
import { DropdownsProvider } from '../../../../contexts/DropdownsContext';
import EngineeringDialog from './EngineeringDialog';
import { LABELS } from '../../../../globals/globals';
import { closeEditing, editRow, selectIdxParts, selectPartDraftSections, selectPartsEditing, startEditing } from '../../../../redux/features/configuration/parts/partsConfigurationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import engineeringImg from '../../../../assets/Images/engineering-placeholder.svg';
import FinanceForm from './FinanceForm';
import StoresForm from './StoresForm';
import { GeneralInfo } from './GeneralInfo';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import SupplyChain from './SupplyChain';
import { resetEffState } from '../../../../redux/features/configuration/parts/effectivitySlice';


const EngineeringPlaceholder = ({ part, enablingAction, hideImage }) => {
  const dispatch = useDispatch();

  return (
    enablingAction ?
      <div className='eng-summary'>
        <div className='summary-item'>
          <b>Effecticity</b>
          <span className='placeholder'>No effectivities cofigured</span>
        </div>
        <div className='summary-item'>
          <b>Interchangeability</b>
          <div className='interchange-grid'>
            <div className='type'>

              <span>Both Ways</span>
              <span className='count'>0</span>
            </div>
            <div className='type'>

              <span>One Way Forward</span>
              <span className='count'>0</span>
            </div>
            <div className='type'>

              <span>One Way To Part</span>
              <span className='count'>0</span>
            </div>

          </div>

        </div>
        <div className='summary-item'>
          <b>PN Time Control</b>
          <span className='placeholder'>No time controls cofigured</span>
        </div>

      </div> :
      <div className='placeholder'>
        {!hideImage && <img height={"100px"} src={engineeringImg} />}
        <b>There are no configurations in this panel</b>
        {enablingAction ? <i>To get Started
          <DialogTrigger dialogContent={{
            component: EngineeringDialog,
            props: { part }
          }}
            onCloseCallback={() => dispatch(resetEffState())}

          >
            <a>Click here</a>
          </DialogTrigger>

        </i> : <i>Save the General Information to enable this section</i>}
      </div>
  )
}

const PartConfigurationGrid = ({ part, open, updatePart }) => {

  const { successMsg, warningMsg } = useSnackBar();
  const dispatch = useDispatch();

  // edition status
  const [editing, setEditing] = useState({});
  const isEditingSection = (name) => name in editing;
  // const startEdition = (section) => {
  //   dispatch(startEditing({section, partId: part.id}));
  //   setEditing(prev => ({ ...prev, [section]: true }));
  // }
  // const closeEdition = (section) => {
  //   dispatch(closeEditing({section, partId: part.id}));
  //   setEditing(prev => {
  //     let copy = { ...prev };
  //     delete copy[section];
  //     return copy;
  //   });
  // }

  const draftParts = useSelector(selectPartDraftSections);
  const isUnsavedPart = (part) => draftParts[part.id]?.includes('general');


  // general part info requested at open;
  const [partInfo, setPartInfo] = useState(null);
  useEffect(() => {
    if (open) {
      getPartInfo(part.id).then(response => {
        if (response.data.responseCode === 200) {
          setPartInfo(response.data.load);
          // TODO: merge local storage changes;
        } else {
          warningMsg("Error retrieving the part info", response.data.message);
        }
      }).catch(error => {
        // TODO: hanlde axios Error;
        console.error(error);
      })
    }
  }, [open]);


  const handleGeneralInfo = (values) => {

  }


  const editingParts = useSelector(selectPartsEditing);
  const isEditingPart = (part) => editingParts[part.id]?.includes('general');

  return (
    <div className="part-configuration-grid-component" onKeyDown={(e) => e.stopPropagation()}>

      <GeneralCard ribbon={[{ when: isEditingPart(part) || isUnsavedPart(part), label: isUnsavedPart(part) ? LABELS.DRAFT : LABELS.EDITION_MODE }]}>
        <GeneralInfo propagateChanges={(values) => updatePart(values)} handleValueChange={(values) => handleGeneralInfo(values)} updatePart={(updatedPart) => setPartInfo(updatedPart)} isUnderEdition={isEditingPart(part)} part={partInfo} />
        {/* <GeneralSectionForm onChange={generalFieldHandler} disabled={!isEnabled('general')} open={open} part={part} /> */}
      </GeneralCard>
      <GeneralCard
        dialog={(!partInfo || partInfo?.version === 0) ? null : ({
          component: EngineeringDialog,
          props: { part: partInfo, showName: true },
          onCloseCallback: () => dispatch(resetEffState())
        })}
        title={
          <div className='card-header'>
            <b>
              Engineering
            </b>
          </div>
        }
      >
        <EngineeringPlaceholder part={partInfo} enablingAction={partInfo?.version > 0}></EngineeringPlaceholder>
      </GeneralCard>
      <div className='sub-grid'>
        {/* <GeneralCard title={
        <div className='card-header'>
          <b>
            Supply Chain
          </b>
        </div>
      } ribbon={[{ when: false, label: LABELS.DRAFT }]}>
        
        <EngineeringPlaceholder hideImage part={partInfo}></EngineeringPlaceholder>
      </GeneralCard> */}
        <GeneralCard >
          <SupplyChain disabled={true} open={open} part={partInfo} />
        </GeneralCard>
        <GeneralCard >
          <StoresForm disabled={true} open={open} part={partInfo} />
        </GeneralCard>

      </div>

      <GeneralCard>
        {/* <EngineeringPlaceholder part={partValue ?? part}></EngineeringPlaceholder> */}
        <FinanceForm disabled={true} open={open} part={partInfo} />
      </GeneralCard>

    </div>
  )
}

export default PartConfigurationGrid